<template>
    <div>
        <div class="select__control" ref="control" :class="state">
            <div class="select__control-body" :class="{ 'select__control-body--shift': selectedObjects.length > 0 }" @click.prevent.stop="onShowList">
                <div class="flex-grow-1 d-flex flex-wrap w-100" v-if="selectedObjects.length > 0">
                    <div class="select__selected-item d-flex" v-for="(item, i) in selectedObjects" :class="{ 'fixed': canRemoveKey && item[canRemoveKey] !== undefined && !item[canRemoveKey] }">
                        <slot name="selected-item" v-bind:item="item">
                            <span class="mr-2 text-wrap">{{ item[labelKey] }}</span>
                        </slot>
                        <b-button v-if="!canRemoveKey || canRemoveKey && (item[canRemoveKey] || item[canRemoveKey] === undefined)"
                                  class="select__dropdown-button"
                                  @click.prevent.stop="onRemoveSelected(item)">
                            <b-icon icon="x" />
                        </b-button>
                    </div>
                </div>
                <div class="flex-grow-1 d-flex flex-wrap w-100" v-else-if="placeholder && showPlaceholder">
                    <span class="text-secondary mr-2">{{ placeholder }}</span>
                </div>
                <div class="flex-grow-1 d-flex flex-wrap w-100" v-else>
                </div>
                <div class="select__control--dropdown-button flex-grow-0">
                    <b-button v-if="!loading" class="select__dropdown-button" @click.prevent.stop="onShowList"><b-icon icon="chevron-down" /></b-button>
                    <b-button v-else class="select__dropdown-button"><b-spinner variant="secondary" small /></b-button>
                </div>
            </div>

            <div class="select__dropdown" ref="dropdown" v-show="dropdownVisible" v-click-outside="hideDropdown">
                <div class="select__dropdown-title">
                    <div v-if="label" :class="{'mb-3': hasSearch}"><strong>{{ label }}</strong></div>
                    <div class="select__dropdown--search mb-2" v-if="hasSearch">
                        <input type="text" @input="onSearch" :placeholder="searchPlaceholder" class="mr-1">
                        <b-icon icon="search" class="text-secondary"/>
                    </div>
                </div>
                <div class="select__dropdown-body">
                    <div class="select__dropdown-options" v-if="!loading && options.length">
                        <div v-for="(option, i) in options" class="select__dropdown-item d-flex align-items-center"
                             :class="{ 'selected': isOptionSelected(option) }" @click="onItemClick(option)">
                            <div class="flex-grow-1">
                                <slot name="option" v-bind:item="option.data">
                                    <span>{{ option.text }}</span>
                                </slot>
                            </div>
                            <h3 class="p-0 m-0 text-info"><b-icon icon="check" v-if="isOptionSelected(option)"/></h3>
                        </div>
                    </div>
                    <div class="select__dropdown-loading" v-else-if="loading">
                        <b-spinner variant="info"></b-spinner>
                    </div>
                    <div v-else>
                        <div class="select__dropdown-options select__dropdown--empty">
                            <span v-if="!loadingError">Результаты не найдены</span>
                            <span v-else class="text-danger">Ошибка загрузки</span>
                        </div>
                    </div>
                </div>
                <div class="select__dropdown-pagination" v-show="pagesCount > 1 && !loading">
                    <b-button class="select__dropdown-button p-3" @click="onChangePage(-1)" :disabled="page === 1">
                        <b-icon v-if="page !== 1" icon="chevron-left" variant="info"/>
                        <b-icon v-else icon="chevron-left" variant="secondary"/>
                    </b-button>
                    <b-button class="select__dropdown-button p-3" @click="onChangePage(1)" :disabled="page === pagesCount">
                        <b-icon v-if="page !== pagesCount" icon="chevron-right" variant="info"/>
                        <b-icon v-else icon="chevron-right" variant="secondary"/>
                    </b-button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { SelectMixin } from "@/components/Select/selectMixin";

export default {
    name: "ListSelect",
    mixins: [ SelectMixin ],
    props: {
        placeholder: { type: String, default: "Выберите из списка" },
        selectedObjects: { type: Array, default: () => { return [] } },  // модель
        canRemoveKey: { type: String, default: null }
    },
    model: {
        prop: 'selectedObjects',
        event: 'selected-objects-changed'
    },
    computed: {
        modelValue: {
            get: function () {
                return this.selectedObjects
            },
            set: function (value) {
                this.$emit('selected-objects-changed', value)
            }
        }
    },
    methods: {
        _add(item) {  // from options to model
            this.modelValue.push(item)
        },
        _remove(item) {
            for (const i in this.modelValue) {
                if (this.modelValue[i][this.idKey] === item[this.idKey]) {
                    this.modelValue.splice(i, 1)
                    return
                }
            }
        },
        isOptionSelected(option) {
            return this.selectedObjects.map(x => x[this.idKey]).includes(option[this.idKey])
        },
        onItemClick(item) {
            const itemData = this.optionData.find(x => x[this.idKey] === item[this.idKey])
            if (this.canRemoveKey && itemData[this.canRemoveKey]) {
                return
            }
            if (this.isOptionSelected(item)) {
                this._remove(itemData);
                this.$emit('select-removed', this.name, itemData)
            } else {
                this._add(itemData);
                this.$emit('select-added', this.name, itemData)
            }
        },
        onRemoveSelected(item) {
            this._remove(item);
            this.$emit('select-removed', this.name, item)
        },
        remove(value) {
            for (const i in this.modelValue) {
                if (this.modelValue[i][this.idKey] === value) {
                    this.modelValue.splice(i, 1)
                    return
                }
            }
        },
        reset() {
            this.modelValue = [];
        }

    }
}
</script>

<style scoped lang="scss">

</style>